import { call, put, all, takeEvery, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";


import {
    // UPDATE_GPT_WEB_CHAT_PAGE_NUMBER,
    GET_GPT_WEB_CHAT_PENDING,
    GET_GPT_WEB_CHATS,
    SG_GET_GPT_WEB_CHATS,
    DELETE_GPT_WEB_CHAT,
    SG_DELETE_GPT_WEB_CHAT,
    FETCH_GPT_WEB_CHAT,
    SG_FETCH_GPT_WEB_CHAT,
    EDIT_GPT_WEB_CHAT,
    SG_EDIT_GPT_WEB_CHAT,
    ADD_GPT_WEB_CHAT,
    SG_ADD_GPT_WEB_CHAT,
    // CLEAR_GPT_WEB_CHAT,
    ALL_ERRORS,
} from "constants/actions";
import { handleError } from "./ApiError";


function* loadmethods(action) {
    yield put({ type: GET_GPT_WEB_CHAT_PENDING });
  // console.log('action.payload', action.payload)
  try {
    const json = yield call(api.GET_CHAT_GPT_WEB_CHATS, action.payload);
    // console.log(json.data)
    yield put({ type: GET_GPT_WEB_CHATS, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodLoad() {
  yield takeEvery(SG_GET_GPT_WEB_CHATS, loadmethods);
}


function* fetchmethods(action) {
    yield put({ type: GET_GPT_WEB_CHAT_PENDING });
  try {
    const json = yield call(api.FETCH_CHAT_GPT_WEB_CHAT, action.payload);
    yield put({ type: FETCH_GPT_WEB_CHAT, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodFetch() {
  yield takeLatest(SG_FETCH_GPT_WEB_CHAT, fetchmethods);
}

function* updatemethods(action) {
  yield put({ type: GET_GPT_WEB_CHAT_PENDING });
  try {
    const json = yield call(api.EDIT_CHAT_GPT_WEB_CHAT, action.payload);
    yield put({ type: EDIT_GPT_WEB_CHAT, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodUpdate() {
  yield takeLatest(SG_EDIT_GPT_WEB_CHAT, updatemethods);
}

function* addmethods(action) {
  yield put({ type: GET_GPT_WEB_CHAT_PENDING });
  try {
    const json = yield call(api.ADD_CHAT_GPT_WEB_CHAT, action.payload);
    yield put({ type: ADD_GPT_WEB_CHAT, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodAdd() {
  yield takeLatest(SG_ADD_GPT_WEB_CHAT, addmethods);
}

function* deletemethods(action) {
  try {
    yield call(api.DELETE_CHAT_GPT_WEB_CHAT, action.payload);
    yield put({ type: DELETE_GPT_WEB_CHAT, payload: action.payload });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodDelete() {
  yield takeLatest(SG_DELETE_GPT_WEB_CHAT, deletemethods);
}

export default function* index() {
  yield all([
    methodLoad(),
    methodFetch(),
    methodUpdate(),
    methodAdd(),
    methodDelete(),
  ]);
}
